export default "<input type=\"text\" class=\"timepicker\" #timepicker>\n"